import actions from './actions'

export default function WorkOrderAdditionalCostsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERADDITIONALCOST:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERADDITIONALCOST:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERADDITIONALCOST:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERADDITIONALCOST:
      return {
        ...state,
        editing: { workOrderAdditionalCostID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERADDITIONALCOST_RECIEVED ||
      actions.UPDATE_WORKORDERADDITIONALCOST_RECIEVED ||
      actions.DELETE_WORKORDERADDITIONALCOST_RECIEVED:
      return {
        ...state,
        editing: { workOrderAdditionalCostID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
